module.exports = __webpack_public_path__ + "img/tp2.a1c4449d.jpg";